import { classesConstants as classes } from "../../../constants/classes";

const initialState = { loading: true, list: [], classe: null, etudiants: [], searchEtudiants:[] };

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case classes.GET_CLASSES:
      return {
        ...state,
        loading: false,
        list: payload,
      };
    case classes.GET_CLASSE:
      return {
        ...state,
        loading: false,
        classe: payload,
      };
    case classes.GET_ETUDIANTS:
      return {
        ...state,
        loading: false,
        etudiants: payload,
      };
    case classes.GET_SEARCH_ETUDIANTS:
      return {
        ...state,
        loading: false,
        searchEtudiants: payload,
      };
    default:
      return state;
  }
}
